import { capitalize } from './utils';

export const formatAllergens = (ingredients: string, allergens: string[], globalAllergenWords: string[]) => {

  const presentAllergens = new Set(ingredients.toLowerCase()
    .split(/\W+/)
    .filter(word => allergens.includes(word))
  )
  const formattedGlobalAllergenWords = globalAllergenWords.map(word => word.toLowerCase())

  const detectedAllergens = new Set(ingredients.toLowerCase()
    .split(/\W+/)
    .filter(word => formattedGlobalAllergenWords.includes(word))
  )
  for (const allergen of detectedAllergens) {
    presentAllergens.add(allergen)
  }
  const formattedAllergens = [...presentAllergens].map(allergen => capitalize(allergen)).join(", ")

  return formattedAllergens
}

export const allergensProductMayContain = (allergensProductMayContain: string) => {
  // Format the allergenMayContain list from BM
  if (allergensProductMayContain?.length > 0) {
    const possibleAllergens = () => {
      const allergensProductMayContainArray = []
      for (let i = 0; i < allergensProductMayContain.length; i++) {
        // Capitalize each possible allergen
        const capitalizedAllergen = allergensProductMayContain[i].charAt(0).toUpperCase() + allergensProductMayContain[i].slice(1)
        allergensProductMayContainArray.push(capitalizedAllergen)
      }
      return allergensProductMayContainArray.join(', ')
    }
    allergensProductMayContain = possibleAllergens()
  }
  return allergensProductMayContain;
}

export const highlightIngredientsWithAllergens = (ingredients: string, allergens?: string[]): string => {
  if (!allergens || !allergens.length) {
    // Adds a line break to separate the block of text
    return ingredients.replace(/May contain/gi, '<br><br>May contain')
  }

  // Splits any string with 'containing' and removes it from the allergen list
  const splitAllergens = allergens.flatMap(allergen => allergen.includes('containing') ? allergen.split(' ').filter(word => word !== 'containing') : [allergen])

  const getTemplate = (allergen: string) =>
    `<b style="text-decoration: underline">${allergen.charAt(0).toUpperCase() + allergen.substring(1)
    }</b>`

  for (const allergen of splitAllergens) {
    const regex = new RegExp(`\\b${allergen}\\b`, 'gi')
    ingredients = ingredients.replace(regex, getTemplate(allergen))
  }
  // Adds a line break to separate the block of text
  ingredients = ingredients.replace(/May contain/gi, '<br><br>May contain')
  return ingredients
}